module.exports = __webpack_public_path__ + "img/Icon_file_download.b50c1542.svg";